<template>
  <aside aria-label="Order Summary">
    <transition name="fade" mode="out-in">
      <SummaryBarSelection v-if="!isSuccessMode" @success="onSuccess" />
      <SummaryBarSuccess v-else @add-more="handleAddMore" />
    </transition>
  </aside>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import SummaryBarSelection from './SummaryBarSelection.vue';
import SummaryBarSuccess from './SummaryBarSuccess.vue';
import { useCollectionSelectionStore } from '~/stores/useCollectionSelectionStore';

const selectionStore = useCollectionSelectionStore();
const isSuccessMode = ref(false);

const onSuccess = () => {
  isSuccessMode.value = true;
  selectionStore.clearSelection(true);
};

const handleAddMore = () => {
  isSuccessMode.value = false;
  selectionStore.clearSelection(true);
};

/**
 * Reset success mode if user starts selecting new items.
 */
watch(
  () => selectionStore.totalQuantity,
  (newQty) => {
    if (isSuccessMode.value && newQty > 0) {
      isSuccessMode.value = false;
    }
  },
);
</script>
